import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-blogdetails',
  templateUrl: './blogdetails.component.html',
  styleUrls: ['./blogdetails.component.css']
})
export class BlogdetailsComponent implements OnInit {

  constructor(private titleService: Title,    private route: ActivatedRoute
  ) {}

  selectedCategory: string = '';
  category: string | null = "burgers";
 
  ngOnInit() {
    debugger;
    this.titleService.setTitle('LaBurgers | News');

    // Detect /menu/burgers OR /menu
    this.route.params.subscribe(params => {
      this.category = params['category'] ?? null;

      if (this.category) {
        this.selectedCategory = this.category.toLowerCase();
        console.log("Filtered Category:", this.category);
      } else {
        this.selectedCategory = "burgers"
      }
    });
  }

  filterCategory(cat: string) {
    debugger;
    this.selectedCategory = cat.toLowerCase();
  }
}
